import { Eyebrow, Reveal } from "@/components/Reveal";

const STEPS = [
    {
        num: "01",
        title: "Discovery & Brief",
        desc: "Audience analysis, creator persona modeling and campaign KPI alignment before anything goes live.",
    },
    {
        num: "02",
        title: "Strategic Casting",
        desc: "Vetting the 3,200+ partner network for the best brand-creator fit across tiers and languages.",
    },
    {
        num: "03",
        title: "Production & Quality",
        desc: "Briefing, content production, compliance checks and asset delivery with clear approval workflows.",
    },
    {
        num: "04",
        title: "Amplify & Whitelist",
        desc: "Organic launch and paid creator whitelisting run simultaneously, so nothing waits.",
    },
    {
        num: "05",
        title: "Optimize & Report",
        desc: "Live media optimization, attribution reporting and a clear ROAS breakdown you can act on.",
    },
];

export default function Process() {
    return (
        <section id="process" data-testid="process-section" className="bg-paper py-16 sm:py-24">
            <div className="mx-auto max-w-6xl px-5 sm:px-8">
                <Reveal className="mb-12 max-w-3xl">
                    <Eyebrow tone="light">How we work</Eyebrow>
                    <h2 className="mt-4 font-syne text-3xl font-bold tracking-tight text-ink sm:text-5xl">
                        Five steps. No gaps.
                    </h2>
                </Reveal>

                <div>
                    {STEPS.map((s, i) => (
                        <Reveal key={s.num} delay={i * 0.05} testid={`process-step-${i + 1}`}>
                            <div className="group grid grid-cols-[auto_1fr] items-start gap-5 border-t border-line py-8 transition-colors duration-300 last:border-b hover:bg-white sm:grid-cols-[120px_1fr_1.2fr] sm:items-center sm:gap-8 sm:px-6">
                                <span className="font-mono text-sm text-slate-400 transition-colors duration-300 group-hover:text-crimson">
                                    /{s.num}
                                </span>
                                <h3 className="font-syne text-xl font-bold tracking-tight text-ink sm:text-2xl">
                                    {s.title}
                                </h3>
                                <p className="col-span-2 text-sm leading-relaxed text-slate-600 sm:col-span-1">
                                    {s.desc}
                                </p>
                            </div>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
